import React, {useEffect, useState} from 'react';
import PhoneInput,{formatPhoneNumber,formatPhoneNumberIntl ,isValidPhoneNumber } from 'react-phone-number-input'
// import PhoneInput from 'react-phone-number-input/react-hook-form-input'
import { useForm,Controller } from "react-hook-form";

const  UserPhoneNumber =(props)=> {
const { isRequired ,onInputChange,errorClass,value } = props;
    const [phone, setPhone] = useState(value)
    const [defaultCountry, setDefaultCountry] = useState("IN")
    useEffect(async() => {
        console.log(value)
        if(value){
            if(value.includes("+91")){
                await setPhone(value)
            }else{
                await setPhone("+91"+value)
            }
            console.log(phone,value)
            // debugger;
        }
      }, [value]); 
      useEffect(() => {
       setDefaultCountry(defaultCountry)
      }, [defaultCountry]);
      
const handlePhoneValidation =(data)=>{
    console.log(data)
    if(data){
        setPhone(data)
        if(isValidPhoneNumber(data)){
            console.log(data)
            setPhone(data)
        onInputChange({
            isRequired,
            isValid : true,
            data: data
        })
        }else{
        onInputChange({
            isRequired,
            isValid : false,
            data: data
        })
        }
    }else{
        setPhone(null)
        onInputChange({})
    }
    
  }
  return (
    <>
    { isRequired ? (
        <>
            {/* <Controller
                name="phoneNumber"
                control={control}
                render={({ field }) => (
                <PhoneInput
                defaultCountry={defaultCountry}
                placeholder="Enter phone number"
                value={phone}
                onChange={handlePhoneValidation}
                className={`form-control ${errors.phoneNumber ? "is-invalid" : ""}`}
                countries={["IN"]}
                international={false}
                    countryCallingCodeEditable={false}
                />
                )}
            /> */}
           
            </>
    ):(
        <>
                <PhoneInput
                    country={"IN"}
                    defaultCountry={defaultCountry}
                    name={Math.random()}
                    countries={["IN"]}
                    placeholder="Enter phone number"
                    value={phone}
                    initialValueFormat="national"
                    onChange={handlePhoneValidation}
                    className={errorClass}
                    international={false}
                    countryCallingCodeEditable={false}
                    withCountryCallingCode={true}
                    {...props}
                    />
                    

        </>
    )}
    </>
  );
}
export default UserPhoneNumber;